import { createTheme } from '@mui/material';

// 全画面共通のtheme定義
const Theme = createTheme({
  palette: {
    primary: {
      main: '#5A87C8',
      light: '#3D88F4',
    },
    secondary: {
      main: '#353536',
    },
    error: {
      main: '#BA1A1A',
    },
    outline: {
      main: '#D9D9D9',
    },
    text: {
      primary: '#353536',
      disabled: '#CCCCCC',
    },
    darkgray: '#6D6C74',
    jiyuu: '#8CB2C8',
    yellow: '#FEFD00',
    red: '#F30602',
    white: '#ffffff',
    brown: '#9B6333',
    green: '#3A7E2E',
    yellowPale: '#FEFDCF',
    redPale: '#FCC8CE',
    brownPale: '#E8DED5',
    greenPale: '#E5F8E2',
    blackPale: '#7C7C7C',
    divider: '#EBEBEB',
    background: {
      default: '#FAFAFA',
    },
    backgroundBlue: '#F2F6FB',
    disabledAaaaaa: '#AAAAAA',
    disabledCccccc: '#CCCCCC',
    white: '#FFFFFF',
    clear: {
      main: '#00000000',
    },
  },
  typography: {
    fontFamily: 'Hiragino Kaku Gothic Pro',
    head20: {
      color: 'var(--text-main, #353536)',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '150%', /* 30px */
    },
    head32bold: {
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: '48px',
    },
    head18: {
      fontSize: '18px',
      fontWeight: 300,
      lineHeight: '27px',
    },
    body16bold: {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
    },
    body16: {
      fontSize: '16px',
      fontWeight: 300,
      lineHeight: '24px',
    },
    body14bold: {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '21px',
    },
    body14: {
      fontSize: '14px',
      fontWeight: 300,
      lineHeight: '21px',
    },
    label14bold: {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '21px',
    },
    label14: {
      fontSize: '14px',
      fontWeight: 300,
      lineHeight: '21px',
    },
    caption13bold: {
      fontSize: '13px',
      fontWeight: 600,
      lineHeight: '20px',
    },
    caption13: {
      fontSize: '13px',
      fontWeight: 300,
      lineHeight: '20px',
    },
    caption12bold: {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '18px',
    },
    caption12: {
      fontSize: 12,
      fontWeight: 300,
      lineHeight: '18px',
    },
    caption11half: {
      fontSize: 11.5,
      fontWeight: 300,
      lineHeight: '18px',
    },
    tab: {
      fontStyle: 'italic',
    },
  },
  // MUIコンポーネントのスタイルを上書きする
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: '#FAFAFA',
        },
      },
      // 自作variant
      variants: [
        {
          props: { variant: 'selected' },
          style: {
            'backgroundColor': '#6D6C74',
            'color': 'white',
            ':hover': {
              backgroundColor: '#6D6C74',
            },
          },
        },
      ],
    },
    MuiTabs: {
      styleOverrides: {
        fixed: {
          '@media (min-width: 1200px)': {
            maxWidth: '1200px',
          },
          '@media (min-width: 600px)': {
            padding: '0px 24px',
            marginLeft: 'auto',
            marginRight: 'auto',
          },
        },
        indicator: {
          height: '4px',
          backgroundColor: '#3D88F4',
        },
      },
      variants: [
        {
          props: { variant: 'selected' },
          style: {
            color: 'white',
          },
        },
      ],
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            fontWeight: 600,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          'color': '#5A87C8',
          '&.Mui-checked': {
            color: '#5A87C8',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          'color': '#5A87C8',
          '&.Mui-checked': {
            color: '#5A87C8',
          },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          border: 'solid 1px', borderColor: '#EBEBEB', borderRadius: '2px',
          backgroundColor: 'white',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#F2F6FB',
        },
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '21px',
            height: '44px',
            backgroundColor: '#3D88F4',
            borderRadius: '100px',
          },
        },
      ],
    },
  },
});

export default Theme;